<!--
 * @Author: 71
 * @Date: 2025-09-08 14:31:21
 * @LastEditTime: 2025-09-19 13:59:16
 * @LastEditors: 71
 * @Description: 校园行事历列表 - activityCalendar
 * @FilePath: \aigoes-school-web\src\views\school\schoolActivityCalendar\schoolActivityCalendarList.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="活动范围">
              <j-select-multiple
                v-model="queryParam.gradeId"
                placeholder="请选择"
                :options="activityCalendarScopeOptions"
              ></j-select-multiple>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="活动状态">
              <j-dict-select-tag
                v-model="queryParam.publishStatus"
                placeholder="请选择"
                dictCode="publish_status"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="家长可见">
              <j-dict-select-tag
                v-model="queryParam.acParentVisible"
                placeholder="请选择"
                dictCode="publish_status"
              />
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="活动时间">
              <a-range-picker :style="{minWidth: '256px'}" @change="onRangeChange" :value="acDateRange" />
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="活动时间（中文）">
              <a-input v-model="queryParam.acDateName" placeholder="请输入活动时间"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="活动名称">
              <a-input 
                v-model="queryParam.title" 
                placeholder="请输入活动名称"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px" v-if="false">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('校园动态表')" v-if="false">
        导出
      </a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
        v-if="false"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="sumaryInfoSlot" slot-scope="text, record">
          <div class="sumary-info-column">
            <div classs="left-img">
               <img
                :src="getImgView(text)"
                @click="showImgDialog(getImgView(text))"
                height="80px"
                alt
                style="max-width: 80px; font-size: 12px; font-style: italic"
              />
            </div>
            <div class="right-txt">
              <span class="title">{{record.title}}</span>
              <span class="time">{{record.beginDate + ' 至 ' + record.endDate}}</span>
            </div>
          </div>
        </template>
        <template slot="picUrl" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="80px"
            alt
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button v-else :ghost="true" type="primary" size="small" @click="preview(text)">
            预览视频
          </a-button>
        </template>
        <template slot="dateRangeSlot" slot-scope="text, record">
          <span v-if="!record.beginDate && !record.endDate" style="font-size: 12px; font-style: italic">-</span>
          <span>{{record.beginDate + '到' + record.endDate}}</span>
        </template>
        <template slot="publishSlot" slot-scope="text, record">
          <a-switch :checked="text" @change="changePublishStatus(record.id, text)"/>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="publish(record)">发布</a>
          <a-divider type="vertical" /> -->
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <SchoolActivityVideo ref="carLocation"></SchoolActivityVideo>
    <SchoolActivityCalendarModal ref="modalForm" @ok="modalFormOk"></SchoolActivityCalendarModal>
    <!-- 内容预览模态框 -->
    <j-modal
      title="预览"
      :width="800"
      :visible="previewVisible"
      @cancel="closePreview"
      :footer="null"
      :maskClosable="true"
    >
      <div v-html="previewContent" style="max-height: 600px; overflow-y: auto;"></div>
    </j-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SchoolActivityCalendarModal from './modules/SchoolActivityCalendarModal'
import SchoolActivityVideo from './modules/SchoolActivityVideo'
import JSelectMultiple from '../../../components/jeecg/JSelectMultiple.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { httpAction } from '@api/manage'
import { getAction, postAction, postActions } from '../../../api/manage'
import { message } from 'ant-design-vue'
import { defineComponent } from 'vue'
import { ajaxGetDictItems, getDictItemsFromCache } from '@/api/api'

export default {
  name: 'SchoolActivityCalendarList',
  mixins: [JeecgListMixin],
  components: {
    SchoolActivityCalendarModal,
    JSearchSelectTag,
    SchoolActivityVideo,
    JSelectMultiple,
  },
  data() {
    return {
      description: '校园动态表管理页面',
      acDateRange: [], // 因为后端没有这个参数属性，所以放在data中
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '作品',
          align: 'center',
          dataIndex: 'picUrl',
          width: 300,
          scopedSlots: { customRender: 'sumaryInfoSlot' },
        },
        // {
        //   title: '封面',
        //   align: 'center',
        //   dataIndex: 'picUrl',
        //   scopedSlots: { customRender: 'picUrl' },
        // },
        {
          title: '活动范围',
          align: 'center',
          dataIndex: 'gradeId_dictText',
          customRender: (text, record) => {
            // 当 gradeId 为 null 或 undefined 时显示"全校可见"
            if (!record.gradeId) {
              return <span style="">全校</span>;
            }
            // 否则显示原来的字典文本
            return text || '-';
          }
        },
        {
          title: '家长是否可见',
          align: 'center',
          dataIndex: 'visible_dictText',
        },
        {
          title: '活动内容',
          align: 'center',
          dataIndex: 'content',
          // customRender: (_, record) => {
          //   return record.content.length >= 25 ? (
          //     <a-tooltip>
          //       <template slot="title">{record.content}</template>
          //       {record.content.substring(0, 25) + '...'}
          //     </a-tooltip>
          //   ) : (
          //     record.content
          //   )
          // },
          customRender: (_, record) => {
            return (
              <a onClick={() => this.showContentPreview(record.content)}>
                预览
              </a>
            );
          },
        },
        {
          title: '发布者',
          align: 'center',
          dataIndex: 'sysUser.realname',
        },
        // {
        //   title: '活动时间',
        //   align: 'center',
        //   scopedSlots: { customRender: 'dateRangeSlot' },
        // },
        {
          title: '是否上架',
          align: 'center',
          dataIndex: 'publishStatus',
          scopedSlots: { customRender: 'publishSlot' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      activityCalendarScopeOptions: [],
      previewContent: '',      // 用于存储预览内容
      previewVisible: false,   // 控制预览模态框显示
      url: {
        list: '/aigoes/schoolActivityCalendar/list',
        edit: '/aigoes/schoolActivityCalendar/edit',
        delete: '/aigoes/schoolActivityCalendar/delete',
        deleteBatch: '/aigoes/schoolActivityCalendar/deleteBatch',
        // exportXlsUrl: 'aigoes/schoolActivityCalendar/exportXls',
        // importExcelUrl: 'aigoes/schoolActivityCalendar/importExcel',
      },
      
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  mounted() {
    // 初始化 Video.js 播放器
    this.player = videojs(this.$refs.myVideo, {
      // 设置播放器的选项，可根据需要进行配置
    })
  },
  beforeDestroy() {
    // 销毁 Video.js 播放器
    if (this.player) {
      this.player.dispose()
    }
  },
  created() {
    this.init()
  },
  methods: {
    // loadData(arg) { // todo remove
    //   //加载数据 若传入参数1则加载第一页的内容
    //   if (arg === 1) {
    //     this.ipagination.current = 1
    //   }
    //   var params = this.getQueryParams() //查询条件
    //   this.queryParam = params;
    //   debugger;
    //   console.log('71', this.queryParam);
    //   this.loading = true
    //   let res = {
    //       "success": true,
    //       "message": "操作成功！",
    //       "code": 200,
    //       "result": {
    //           "records": [
    //               {
    //                   "visible": 1,
    //                   "visible_dictText": "可见",
    //                   "updateTime": "2025-09-09 10:45:31",
    //                   "title": "秋游活动",
    //                   "content": "<p>文章开头</p><p><img src=\"http://192.168.0.160:90/school-app-api/sys/common/static//null/2025-09-10/175748866965260083782.png\" alt=\"\" data-href=\"\" style=\"width: 346.00px;height: 196.47px;\"/></p><p>文章内容</p><p><u><em>biubiubiu</em></u></p><p>文章结束</p>",
    //                   "schoolClass": {
    //                       "gradeName": "",
    //                       "gradeId": "",
    //                       "teacherName": "",
    //                       "enrollmentDate": "",
    //                       "headteacherId": "",
    //                       "updateTime": "",
    //                       "deleteFlag": "",
    //                       "createBy": "",
    //                       "createTime": "",
    //                       "updateBy": "",
    //                       "sortOrder": "",
    //                       "name": "",
    //                       "tenantId": "",
    //                       "id": ""
    //                   },
    //                   "date": "202510",
    //                   "dateStr": "2025年10月",
    //                   "picUrl": "/temp/2024-12-26/173519402342333101723.png",
    //                   "createBy": "e9ca23d68d884d4ebb19d07889727dae",
    //                   "classId": "1111",
    //                   "publishStatus": 0, // 1表示发布，0表示未发布
    //                   "publishStatus_dictText": "已发布",
    //                   "videoUrl": "",
    //                   "createTime": "2024-12-26 14:20:27",
    //                   "updateBy": "admin",
    //                   "tenantId": 4,
    //                   "classId_dictText": "七年级1班",
    //                   "id": "1872165556700127233",
    //                   "sysUser": {
    //                       "relTenantIds": "4,14,1,3,5,6,8,7,9,10,11,12,13,15,16,17,18,19,21,20,22,23,25",
    //                       "thirdId": "1",
    //                       "updateTime": "2025-02-27 15:27:24",
    //                       "avatar": "/DefaultAvatar/@2x1024-1024.png",
    //                       "userIdentity": "1,2,20",
    //                       "realname": "管理员",
    //                       "deleteFlag": 0,
    //                       "createBy": "",
    //                       "face": "",
    //                       "createTime": "2024-06-21 17:54:10",
    //                       "updateBy": "admin",
    //                       "phone": "13111111111",
    //                       "id": "e9ca23d68d884d4ebb19d07889727dae",
    //                       "thirdType": "dingtalk",
    //                       "username": "admin",
    //                       "status": 1
    //                   },
                      
    //               }
    //           ],
    //           "total": 1,
    //           "size": 10,
    //           "current": 1,
    //           "orders": [],
    //           "optimizeCountSql": true,
    //           "searchCount": true,
    //           "countId": "",
    //           "maxLimit": "",
    //           "pages": 1
    //       },
    //       "timestamp": 1757386086264
    //   }
    //   if (res.success) {
    //     this.dataSource = res.result.records.map((item, index) => ({
    //       ...item,
    //       index: index + 1,
    //     }))
    //     // if (this.isExpandFirst && this.dataSource[0]) {
    //     //   this.expandedRowKeys = [this.dataSource[0][this.rowKey]]
    //     // }
    //     console.log('源数据：', this.dataSource)
    //     this.ipagination.total = res.result.total
    //   }
    //   if (res.code === 510) {
    //     this.$message.warning(res.message)
    //   }
    //   this.loading = false
    // },
    init() {
      this.loadDict();
    },
    loadDict() { 
      // let dictCode = 'school_class,name,id,delete_flag=0'; // 班级
      let dictCode = 'school_grade,grade_name,id,delete_flag=0'; // 年级
      //优先从缓存中读取字典配置
      if (getDictItemsFromCache(dictCode)) {
        this.activityCalendarScopeOptions = getDictItemsFromCache(dictCode)
        return
      }
      //根据字典Code, 初始化字典数组
      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          let extraOptions = [{ value: 'ALL71', text: '全校', title: '全校' }];
          this.activityCalendarScopeOptions = [...extraOptions, ...res.result];
        }
      })
    },
    changePublishStatus(recordId, publishStatus) {
      console.log(publishStatus)
      let params = {
        id: recordId,
        publishStatus: !publishStatus ? 1 : 0,
      }
      console.log(params)
      postAction(this.url.edit, params).then((res) => {
        message.success({ content: '发布成功!', duration: 1 })
        console.log(res)
        this.loadData()
      })
    },
    publish(record) {
      let params = {
        id: record.id,
        publishStatus: 1,
      }
      postAction('/aigoes/schoolActivity/edit', params).then((res) => {
        message.success({ content: '发布成功!', duration: 1 })
        console.log(res)
        this.loadData()
      })
    },
    preview(video) {
      console.log(video)
      this.$refs.carLocation.edit(video)
    },
    // 显示内容预览
    showContentPreview(content) {
      this.previewContent = content || '';
      this.previewVisible = true;
    },
    // 关闭预览
    closePreview() {
      this.previewVisible = false;
      this.previewContent = '';
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.queryParam.rangeType = 'range'
      this.acDateRange = dates;
      // this.$set(this.queryParam, 'acDateRange', dates);
      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.sumary-info-column {
  min-width: 300px;
  max-width: 500px;
  display: flex;
  flex-direction: row;
  .left-img {
    width: 80px;
    flex-shrink: 0;
  }
  .right-txt {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    padding-left: 10px;
    min-width: 0; /* 关键：允许子元素收缩 */
    // 超出省略号
    .title, .time {
      width: 100%;
      text-align: left;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      
    }
  }
}
</style>
